<template>
  <router-view />
</template>

<script>
export default {
  name: 'ProductStorageTransfersIndex'
}
</script>
